<template>
   <v-col class="pt-0" cols="12" sm="12">
        <!-- >>> Title -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <h2 v-if="leg === 'firstLeg'" class="mb-8">
                    First Leg
                </h2>
                <h2 v-if="leg === 'secondLeg'" class="mb-8">
                    Second Leg
                </h2>
            </v-col>
        </v-row>
        <!-- <<< Title -->

        <v-row>
            <v-col cols="12" sm="12">
                <v-select
                    v-model="data[leg].input_dow"
                    :rules ="[
                        rules.req(data[leg].input_dow),
                    ]"
                    :items="items_weekly_DaysOfWeek"
                    item-text="text"
                    name="input_dow"
                    multiple
                    chips
                    prepend-icon="mdi-view-day"
                    return-object
                    @change="onChange_weekly_DaysOfWeek">
                    <template v-slot:label>
                        <p class="mb-0">
                            Series Day(s) <span style="color: red; font-size: 1.4rem;">*</span>
                        </p>
                    </template>
                </v-select>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="4" style="display:flex;align-items:center;">
                <v-menu
                    ref="input_fromDateMenu"
                    v-model="input_fromDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            ref="input_FromDate"
                            v-model="formattedInputFromDate"
                            v-bind="attrs"
                            prepend-icon="mdi-clock-start"
                            clearable
                            :rules ="[
                                    rules.req(data[leg].input_FromDate),
                            ]"
                            readonly
                            v-on="on">
                            <template v-slot:label>
                                Series starts on <span style="color: red; font-size: 1.4rem;">*</span>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="data[leg].input_FromDate"
                        :first-day-of-week="1"
                        @change="onChange_weekly_SaveStartDate" />
                </v-menu>
            </v-col>

            <v-col style="display: flex; align-items:center" cols="12" sm="1">
                <img style="height:120px;" src="../../../../../../../assets/gant.svg">
            </v-col>

            <v-col style="background:#f5f5f5;border-radius:4px;" cols="12" sm="7" class="pt-6">
                <div style="width:100%">
                    <v-row>
                        <v-col cols="12" sm="3" class="mt-2">
                            <p style="text-align:right;font-size:1.1rem;font-weight:bold;">
                                and ends on
                            </p>
                        </v-col>
                        <v-col cols="12" sm="8" class="pt-0">
                            <v-menu
                                ref="input_toDateMenu"
                                v-model="input_toDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        ref="input_ToDate"
                                        v-model="formattedInputToDate"
                                        v-bind="attrs"
                                        clearable
                                        :rules ="[
                                                rules.req(data[leg].input_ToDate),
                                        ]"
                                        readonly
                                        v-on="on">
                                        <template v-slot:label>
                                            Date <span style="color: red; font-size: 1.4rem;">*</span>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="data[leg].input_ToDate"
                                    :first-day-of-week="1"
                                    @change="onChange_weekly_SaveEndDate" />
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="3" />
                        <v-col style="display:flex;justify-content:center;" cols="12" sm="8">
                            <v-icon style="text-align:center;font-size:1.5rem;" color="primary">
                                mdi-swap-vertical
                            </v-icon>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="3">
                            <p style="text-align:right;font-size:1.1rem;font-weight:bold;" class="ma-0 pt-2">
                                or ends after
                            </p>
                        </v-col>
                        <v-col cols="12" sm="8" class="pt-0">
                            <v-text-field
                                ref="input_NumberOfWeeks"
                                v-model="data[leg].input_NumberOfWeeks"
                                name="input_NumberOfWeeks"
                                type="number"
                                clearable
                                @change="onChange_weekly_SaveWeeks">
                                <template v-slot:label>
                                    Weeks <span style="color: red; font-size: 1.4rem;"></span>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';


    export default {
        name: 'SdrStep2Flightperiod',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            editorFlightLegMode: String, // 'single', 'rotation'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object, // entire 'rules' Object
            showDeleteCheckbox: Boolean,
            onChange_TabChange: Function

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                items_weekly_DaysOfWeek: [
                    {
                        text: '1',
                        value: 'MONDAY',
                        dayOfWeek: 1
                    },
                    {
                        text: '2',
                        value: 'TUESDAY',
                        dayOfWeek: 2
                    },
                    {
                        text: '3',
                        value: 'WEDNESDAY',
                        dayOfWeek: 3
                    },
                    {
                        text: '4',
                        value: 'THURSDAY',
                        dayOfWeek: 4
                    },
                    {
                        text: '5',
                        value: 'FRIDAY',
                        dayOfWeek: 5
                    },
                    {
                        text: '6',
                        value: 'SATURDAY',
                        dayOfWeek: 6
                    },
                    {
                        text: '7',
                        value: 'SUNDAY',
                        dayOfWeek: 0
                    }

                ],
                dates_dateMenu: null,
                input_fromDateMenu: null,
                input_toDateMenu: null
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([

                'get_AircraftConfigs',
                'get_Airports'

            ]),

            /*******************************************************************
            * items_Seasons{}
            *
            * Desc: Delivers 3 items - current season, next season, season after next
            * Desc: sets the current season as default of value input_Season
            * Note: summer season lasts from 27.03 to 30.10 (7 month)
            *
            */
            items_Seasons: {

                get() {

                    const me = this;
                    const tmp_season = [];


                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/items_Seasons/get');
                    for (let i = 0; i < 3; i++) {

                        const addMonth = i * 7;
                        const newDate = dayjs().add(addMonth, 'months');
                        const beginningSummer = dayjs().date(27).month(2).year(newDate.year());
                        const endingSummer = dayjs().date(30).month(9).year(newDate.year());
                        const isBetween = newDate.isBetween(beginningSummer, endingSummer);

                        let season = '';

                        if (isBetween) {
                            season = 'S' + newDate.format('YY');
                        } else {
                            season = 'W' + newDate.format('YY');
                        }

                        tmp_season.push(season);
                    }

                    me.input_Season = tmp_season[0];
                    return tmp_season;

                },

                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/items_Seasons/set');
                    return value;
                }  // eo function items_Seasons{}

            },

            /*******************************************************************
            * formattedInputFromDate{}
            *
            * Desc:
            * Note:
            *
            */
            formattedInputFromDate: {

                get() {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/formattedInputFromDate/get');
                    if (Vue.prototype.$isEmpty(me.data[me.leg].input_FromDate)) {
                        return;
                    }

                    return me.data[me.leg].input_FromDate ? this.formatDateForTextField(me.data[me.leg].input_FromDate) : '';

                }, // eo function formattedInputFromDate get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/formattedInputFromDate/set');
                    me.data[me.leg].input_FromDate = value;
                    return me.data[me.leg].input_FromDate;

                } // eo function formattedInputFromDate set()

            }, // eo function formattedInputFromDate{}

            /*******************************************************************
            * formattedInputToDate{}
            *
            * Desc:
            * Note:
            *
            */
            formattedInputToDate: {

                get() {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/formattedInputToDate/get');
                    if (Vue.prototype.$isEmpty(me.data[me.leg].input_ToDate)) {
                        return;
                    }

                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/formattedInputToDate/get');
                    return me.data[me.leg].input_ToDate ? me.formatDateForTextField(me.data[me.leg].input_ToDate) : '';

                }, // eo function formattedInputToDate get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> computed/formattedInputToDate/set');
                    me.data[me.leg].input_ToDate = value;
                    return me.data[me.leg].input_ToDate;

                } // eo function formattedInputToDate set()

            } // eo function formattedInputToDate{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* watch */
        watch: {

            /*******************************************************************
            * input_dateRange{}
            *
            * Desc:
            * Note:
            *
            */
            input_dateRange (val) {

                const me = this;
                const formattedDates = [];

                if (me.editorMode === 'update') {
                    me.formattedDateRange = dayjs(val).format('DD.MM.YYYY');
                    return;
                }
				me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> watch > input_dateRange');
                //if there are two dates selcted (range)
                //check if the first date is NOT before the second date
                if (val.length === 2) {
                    //switch dates, so the range is valid
                    if (dayjs(val[0]).isAfter(dayjs(val[1]))) {
                        //switch val[0] und val[1]
                        [val[0], val[1]] = [val[1], val[0]];
                    }
                }

                //loop over date range, and save formatted date
                me.input_dateRange.forEach(date => {
                    formattedDates.push(dayjs(date).format('DD.MM.YYYY'));
                });

                me.formattedDateRange = formattedDates.join(' - ');

            } // eo function input_dateRange()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> created');
            eventBus.$on('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function created()
		/* <<< ****************************************************************/



        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> destroyed');
            eventBus.$off('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function destroyed()
        /* <<< *************************************************************** /



        /* >>> ***************************************************************** / /* Methods */
        methods: {


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_weekly_DaysOfWeek()
            *
            * Desc:
            * Note:
            *
            */
            onChange_weekly_DaysOfWeek: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_weekly_DaysOfWeek');
                me.setDatesInRange();

            }, // eo function onChange_weekly_DaysOfWeek()
            /******************************************************************* 'Listeners - DatePickers'
            * onChange_weekly_SaveStartDate()
            *
            * Desc:
            * Note:
            *
            * @param {Object} date ()
            */
            onChange_weekly_SaveStartDate: function(date) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_weekly_SaveStartDate');
                if (dayjs(me.data[me.leg].input_ToDate).isBefore(date)) {
                    me.data[me.leg].input_ToDate = date;
                    me.$refs.input_toDateMenu.save(date);
                    me.onChange_highlightField('input_ToDate');
                }

                me.$refs.input_fromDateMenu.save(date);

                me.setDatesInRange();

                me.onChange_highlightField('input_NumberOfWeeks');

            }, // eo function onChange_weekly_SaveStartDate()

            /******************************************************************* 'Listeners - DatePickers'
            * onChange_weekly_SaveEndDate()
            *
            * Desc:
            * Note:
            *
            *
            * @param {Object} date ()
            */
            onChange_weekly_SaveEndDate: function(date) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_weekly_SaveEndDate');
                if (dayjs(me.data[me.leg].input_FromDate).isAfter(date)) {
                    me.data[me.leg].input_FromDate = date;
                    me.$refs.input_fromDateMenu.save(date);
                    me.onChange_highlightField('input_FromDate');
                }

                me.$refs.input_toDateMenu.save(date);

                me.setDatesInRange();

                me.onChange_highlightField('input_NumberOfWeeks');

            }, // eo function onChange_weekly_SaveEndDate()

            /******************************************************************* 'Listeners - DatePickers'
            * onChange_weekly_SaveWeeks()
            *
            * Desc:
            * Note:
            *
            *
            * @param {Object} date ()
            */
            onChange_weekly_SaveWeeks: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_weekly_SaveWeeks');
                me.data[me.leg].input_ToDate = dayjs(me.data[me.leg].input_FromDate).add(me.data[me.leg].input_NumberOfWeeks, 'weeks').format('YYYY-MM-DD');
                me.setDatesInRange();
                me.onChange_highlightField('input_toDateMenu');

            }, // eo function onChange_weekly_SaveWeeks()

            /******************************************************************* 'Listeners - DatePickers'
            * onChange_dates_SaveStartDate()
            *
            * Desc:
            * Note:
            *
            * @param {Object} date ()
            */
            onChange_dates_SaveStartDate: function(date) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_dates_SaveStartDate');
                me.$refs.input_fromDateMenu.save(date);

            }, // eo function onChange_dates_SaveStartDate()

            /*******************************************************************
            * formatDateForTextField()
            *
            * Desc: Modify the date with the utc filter.
            * Note:
            *
            * @param {Object} date (date to format)
            */
            formatDateForTextField: function(date) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> formatDateForTextField');
                return me.$options.filters.dayjsUtcDe(date, { showDayName: true });

            }, // eo function formatDateForTextField()

            /*******************************************************************
            * setDatesInRange()
            *
            * Desc: Modify the date with the utc filter.
            *
            * @param {Object} date ()
            * @returns {Object} ({total:number,weeks:number,dates:Array<Object>,months:Array<string>})
            */
            setDatesInRange: function() {

                const me = this,
                    datesInRange = {
                        total: 0,
                        weeks: 0,
                        dates: [],
                        months: []
                    };
                let tmp_start,
                    tmp_end,
                    tmp;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> setDatesInRange');
                if (me.data[me.leg].input_FromDate && me.data[me.leg].input_ToDate && me.data[me.leg].input_dow) {

                    tmp_start = dayjs(me.data[me.leg].input_FromDate);
                    tmp_end = dayjs(me.data[me.leg].input_ToDate);
                    //loop over selected days
                    me.data[me.leg].input_dow.forEach(day => {

                        tmp = tmp_start.clone();

                        //get next (selected) day in time range
                        //if startDate is a that week already passed the selected day
                        //go on one week, and select the selected day
                        //dayjs.day(#number) only moves in the current week of startDate,
                        //even if the day is in the past
                        if (tmp_start.get('day') !== day.dayOfWeek) {
                            tmp = tmp_start.add(1, 'week');
                        }
                        tmp = tmp.day(day.dayOfWeek);
                        // check - push - go on 7 days
                        while (tmp.isSameOrBefore(tmp_end)) {
                            datesInRange.dates.push(tmp);
                            datesInRange.total += 1;
                            tmp = tmp.add(7, 'days');
                        }
                    });

                    datesInRange.dates.sort((a, b) => a.isAfter(b) ? 1 : -1);

                    datesInRange.weeks = tmp_end.diff(tmp_start, 'weeks');

                    datesInRange.dates.forEach((date) => {
                        const month = dayjs(date).format('MMMM YYYY');

                        if (datesInRange.months.includes(month) === false) {
                            datesInRange.months.push(month);
                        }
                    });
                }

                me.data[me.leg].input_datesInRange = datesInRange;
                me.data[me.leg].input_NumberOfWeeks = datesInRange.weeks;


                return datesInRange;

            }, // eo function setDatesInRange()

            /*******************************************************************
            * onChange_highlightField{}
            *
            * Desc: Highlights an input field for 1500ms.
            * Note: "HACK": when input_NumberOfWeeks change in the above line the cssClassList
            * Note: will change, so if we want to change the cssClassList too, we need to wait
            *
            * @param {string} fieldName (ref name of input field)
            *
            */
            onChange_highlightField: function(fieldName) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_highlightField');
                if (me.$refs[fieldName] && me.$refs[fieldName].$el) {
                    setTimeout(function() {
                        me.$refs[fieldName].$el.classList.add('input-glow');
                    }, 100);

                    setTimeout(function() {
                        me.$refs[fieldName].$el.classList.remove('input-glow');
                    }, 1600);
                }

            }, // eo function onChange_highlightField()


            /*******************************************************************
            * onChange_deleteForAll
            *
            * Desc:
            * Note:
            *
            */
            onChange_deleteForAll: function(leg, value, type, inputName) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/BottomSheet/Step2SlotPeriod.vue >>> onChange_deleteForAll');
                me.data[me.leg][inputName] = '';
                eventBus.$emit('markToDeleteBus', { leg: leg, type: type, value: value });

            } // eo function onChange_deleteForAll()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
